import { ref } from 'vue'
import { defineStore } from 'pinia'
import mainLoadingBg from '@/assets/images/coin/main-loading-bg.webp'
import { coinSwitchKey } from '@/constants'
import { isTGPlatform } from '@/utils'

export const useInstallStore = defineStore('install', () => {
  const canInstall = ref(false)

  function setInstallPrompt(canInstallValue) {
    canInstall.value = canInstallValue
  }

  return { canInstall, setInstallPrompt }
})

export const useCoinLoadingBarStore = defineStore('coinLoadingBar', () => {
  const showProgressBar = ref(true)
  const mainBg = ref(mainLoadingBg)
  const progress = ref(0)

  function setShowProgressBar(show) {
    showProgressBar.value = show
  }

  function setMainBg(img) {
    mainBg.value = img
  }

  function setProgress(val) {
    progress.value = val
  }

  return { showProgressBar, mainBg, progress, setShowProgressBar, setMainBg, setProgress }
})

export const useGameStore = defineStore(
  'gameStore',
  () => {
    const isRun = ref(false)
    const coinSwitchItem = localStorage.getItem(coinSwitchKey)
    const musicPause = ref(coinSwitchItem == 1)
    const showGuide = ref(false)
    const guideType = ref('')
    const showRetain = ref(false)
    const gameOneceEnd = ref(null)
    const playGreatVoiceStart = ref(null)
    const gameConfig = ref({})
    const dealyDraw = ref(false)
    const drawText = ref('')
    const videoEndEventCalled = ref(false)
    const userInfo = ref({})
    const globalConfig = ref({})
    const showGetChance = ref(false)
    const barrageList = ref([])
    const prizeDeal = ref(null)

    function setBarrageList(list) {
      barrageList.value = list
    }
    function setGlobalConfig(config) {
      globalConfig.value = config
    }
    function setUserInfo(info) {
      userInfo.value = info
    }
    function setVideoEndEventCalled(data) {
      videoEndEventCalled.value = data
    }
    function setDrawText(text) {
      drawText.value = text
    }
    function setDealyDraw(data) {
      dealyDraw.value = data
    }
    function setGameConfig(data) {
      gameConfig.value = data
      const times = `${new Date(data?.termEndTime).getTime()}`
      const localTermEndTime = localStorage.getItem('term_end_t')
      if (!localTermEndTime) {
        localStorage.setItem('term_end_t', times)
      }
      if (localTermEndTime !== times) {
        localStorage.removeItem('d_s_1th_c') // 首次常态化分享
        localStorage.removeItem('a_h_1th_o') // 首次点击底部ask help
        localStorage.removeItem('hp_d') // help double弹窗
        localStorage.removeItem('t_lmt') // time limit弹窗
        localStorage.removeItem('c_s_cnt') // 无抽奖次数点击3次
        localStorage.removeItem('d_s_rec_beh') // 无次数弹窗记录用户行为
        localStorage.setItem('term_end_t', times)
      }
    }
    function setGameOneceEnd(fun) {
      gameOneceEnd.value = fun
    }
    function setPlayGreatVoiceStart(fun) {
      playGreatVoiceStart.value = fun
    }
    function setPrizeDeal(fun) {
      prizeDeal.value = fun
    }
    function setIsRun(val) {
      isRun.value = val
    }
    function setMusicPause(val) {
      musicPause.value = val
      localStorage.setItem(coinSwitchKey, val ? '1' : '0')
    }
    function setShowGuide(val) {
      showGuide.value = val
    }
    function setShowRetain(val) {
      showRetain.value = val
    }
    function setGuideType(val) {
      guideType.value = val
    }
    function setShowGetChance(val) {
      showGetChance.value = val
    }
    return {
      isRun,
      setIsRun,
      musicPause,
      setMusicPause,
      showGuide,
      setShowGuide,
      showRetain,
      setShowRetain,
      guideType,
      setGuideType,
      gameOneceEnd,
      setGameOneceEnd,
      playGreatVoiceStart,
      setPlayGreatVoiceStart,
      gameConfig,
      setGameConfig,
      dealyDraw,
      setDealyDraw,
      drawText,
      setDrawText,
      videoEndEventCalled,
      setVideoEndEventCalled,
      userInfo,
      setUserInfo,
      globalConfig,
      setGlobalConfig,
      showGetChance,
      setShowGetChance,
      barrageList,
      setBarrageList,
      prizeDeal,
      setPrizeDeal
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['musicPause', 'gameConfig', 'userInfo', 'globalConfig', 'showRetain']
    }
  }
)

export const useUserStore = defineStore(
  'userStore',
  () => {
    const userInfo = ref({})

    function setUserInfo(info) {
      userInfo.value = info
    }
    return {
      userInfo,
      setUserInfo
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['userInfo']
    }
  }
)

export const useTgUserStore = defineStore(
  'tgUserStore',
  () => {
    const tgUserInfo = ref({})

    if (isTGPlatform()) {
      tgUserInfo.value = window?.Telegram?.WebApp?.initDataUnsafe?.user || {}
    }

    return {
      tgUserInfo
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['tgUserInfo']
    }
  }
)

export const useBoxStore = defineStore(
  'boxStore',
  () => {
    const userData = ref({})
    const boxData = ref({})
    const audioMap = ref({})

    function setUserData(data) {
      userData.value = data
    }
    function setBoxData(data) {
      boxData.value = data
    }
    function setAudioMap(name, source) {
      audioMap.value[name] = source
    }
    function getAudioMap(name) {
      return audioMap.value[name]
    }

    return {
      userData,
      boxData,
      setUserData,
      setBoxData,
      setAudioMap,
      getAudioMap
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['userData', 'boxData', 'audioMap']
    }
  }
)

export const useSpinStore = defineStore(
  'spinStore',
  () => {
    const userData = ref({})

    function setUserData(data) {
      userData.value = data
    }

    return {
      userData,
      setUserData
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['userData']
    }
  }
)

export const useWheeldrawStore = defineStore(
  'wheeldrawStore',
  () => {
    const lotteryData = ref({})

    function setLotteryData(data) {
      lotteryData.value = data
    }

    return {
      lotteryData,
      setLotteryData
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['lotteryData']
    }
  }
)

export const useAgentRectStore = defineStore(
  'agentRectStore',
  () => {
    const realBRect = ref({})
    const showBRect = ref({})

    function setRealBRect(data) {
      realBRect.value = data
    }

    function setShowBRect(data) {
      showBRect.value = data
    }

    return {
      realBRect,
      showBRect,
      setRealBRect,
      setShowBRect
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['agentRect']
    }
  }
)

export const useBattleStore = defineStore(
  'battleStore',
  () => {
    const battleInfo = ref({})

    function setBattleInfo(data) {
      battleInfo.value = data
    }

    return {
      battleInfo,
      setBattleInfo
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['battleInfo']
    }
  }
)

export const useRefEarnTaskStore = defineStore(
  'refEarnTaskStore',
  () => {
    const refEarnTaskInfo = ref({})

    function setRefEarnTask(data, merge = false) {
      if (merge) {
        refEarnTaskInfo.value = { ...refEarnTaskInfo.value, ...data }
        return
      }
      refEarnTaskInfo.value = data
    }

    return {
      refEarnTaskInfo,
      setRefEarnTask
    }
  },
  {
    persist: {
      storage: window.sessionStorage,
      paths: ['refEarnTaskInfo']
    }
  }
)
